import { toWSDateString } from "@wingspanhq/fe-component-library";

import { convertDateStringToUTCMidday } from "../../../utils/dates";

export const selectorPolicyEffectiveDatesText = (policy: {
  effectiveDate?: string | Date | null;
  expirationDate?: string | Date | null;
}) => {
  if (policy.effectiveDate) {
    return [
      policy.effectiveDate
        ? toWSDateString(
            typeof policy.effectiveDate === "string"
              ? convertDateStringToUTCMidday(policy.effectiveDate)
              : policy.effectiveDate,
            "monthDayYear"
          )
        : null,
      policy.expirationDate
        ? toWSDateString(
            typeof policy.expirationDate === "string"
              ? convertDateStringToUTCMidday(policy.expirationDate)
              : policy.expirationDate,
            "monthDayYear"
          )
        : "Ongoing"
    ].join(" - ");
  }

  return "N/A";
};
